import { AlertTriangle } from "lucide-react";
import { formatDate } from "@/lib/format";

// Oranžová karta „duplicita" nad formulářem dokladu (zadání 149/153). Bez vlastních
// tlačítek — rozhodnutí je v patičce dialogu: jistá shoda se uložit NEDÁ (jen Zahodit /
// Zobrazit existující), podezřelá se uloží a dvojice se řeší v Duplicitních dokladech.
export function DuplicateBanner({ dups, onShow }) {
  if (!dups?.length) return null;
  const certain = dups.some((d) => d.certain);
  return (
    <div className="rounded-[14px] border border-amber-500/40 bg-amber-500/10 p-3" role="alert" data-testid="duplicate-banner">
      <div className="flex items-start gap-2.5">
        <AlertTriangle size={18} className="text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
        <div className="min-w-0 flex-1">
          <p className="font-bold text-sm" data-testid="duplicate-title">
            {certain ? "Tento doklad už v systému je — nelze uložit" : "Možná duplicita — po uložení najdete dvojici v Duplicitních dokladech"}
          </p>
          <div className="mt-2 space-y-2.5">
            {dups.slice(0, 3).map((d) => (
              <div key={d.id} data-testid={`duplicate-${d.id}`}>
                <p className="text-sm leading-snug">
                  <button type="button" className="font-bold underline-offset-2 hover:underline text-left" onClick={() => onShow?.(d)} data-testid={`duplicate-open-${d.id}`}>{d.label}</button>
                  <span className="text-muted-foreground"> · nahrál {d.created_by_name || "—"} {formatDate(d.created_at)}{d.project_name ? ` · ${d.project_name}` : ""}</span>
                </p>
                <div className="flex flex-wrap gap-1 mt-1">
                  {(d.reasons || []).map((r) => <ReasonChip key={r} r={r} />)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export function ReasonChip({ r }) {
  return <span className="bg-amber-500/15 text-amber-700 dark:text-amber-300 rounded-full px-2 text-[11px] font-bold leading-5">{r}</span>;
}

// Posune banner do zorného pole (bez animace při reduced motion).
export function scrollToDuplicateBanner() {
  setTimeout(() => {
    const el = document.querySelector("[data-testid=duplicate-banner]");
    const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    el?.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  }, 50);
}
